import axios from "axios";
import { toast } from "react-toastify";
import { constant } from "../constant";

/**
 * OTP / Borrower Portal:
 * - cookie-based auth (httpOnly cookie)
 * - must send withCredentials: true
 * - should NOT attach Authorization header from localStorage
 */
function getBorrowerToken() {
  return sessionStorage.getItem("borrowerToken") || "";
}

const OTP_AXIOS_CONFIG = {
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
};

function logAxiosError(prefix, error) {
  console.log(prefix, error);
  if (error?.response) {
    console.log("Response data:", error.response.data);
    console.log("Response status:", error.response.status);
    console.log("Response headers:", error.response.headers);
  }
}

export const apigetOtp = (path, config = {}) => {
  const token = getBorrowerToken();
  return axios.get(constant.baseUrl + path, {
    ...config,
    headers: {
      ...(config.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

export const apipostOtp = (path, data, config = {}) => {
  const token = getBorrowerToken();
  return axios.post(constant.baseUrl + path, data, {
    ...config,
    headers: {
      "Content-Type": "application/json",
      ...(config.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

export const apiputOtp = (path, data, config = {}) => {
  const token = getBorrowerToken();
  return axios.put(constant.baseUrl + path, data, {
    ...config,
    headers: {
      "Content-Type": "application/json",
      ...(config.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

export const apipostOtpFormData = (path, formData, config = {}) => {
  const token = getBorrowerToken();

  return axios.post(constant.baseUrl + path, formData, {
    ...config,
    headers: {
      ...(config.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      // Let the browser set the correct multipart boundary:
      // DO NOT set Content-Type manually unless you really know why.
    },
  });
};
/**
 * Optional convenience wrappers for your OTP routes
 * (use these to avoid typos in paths)
 */
/**
 * Start OTP flow.
 * @param {Object} params
 * @param {string} params.method     "email" (default) or "sms"
 * @param {string} [params.emailAddress]  required when method=email
 * @param {string} [params.phoneNumber]   required when method=sms
 */
export const otpStart = async ({ method = "email", emailAddress, phoneNumber } = {}) => {
  return apipostOtp("otp/public/borrower/otp/start", { method, emailAddress, phoneNumber });
};

/**
 * Verify OTP code.
 * @param {Object} params
 * @param {string} params.method     "email" (default) or "sms"
 * @param {string} [params.emailAddress]  required when method=email
 * @param {string} [params.phoneNumber]   required when method=sms
 * @param {string} params.code       6-digit code
 */
export const otpVerify = async ({ method = "email", emailAddress, phoneNumber, code } = {}) => {
  return apipostOtp("otp/public/borrower/otp/verify", { method, emailAddress, phoneNumber, code });
};

export const otpBorrowerMe = async () => {
  return apigetOtp("otp/borrower/me");
};

export const otpBorrowerLoansMe = async () => {
  return apigetOtp("otp/borrower/loans/me");
};

export const getBorrowerCommPrefs = async () => {
  return apigetOtp("otp/borrower/communication-preferences");
};

export const updateBorrowerCommPrefs = async (data) => {
  return apiputOtp("otp/borrower/communication-preferences", data);
};

export const getBorrowerLoanMilestone = async (loanId) => {
  return apigetOtp(`otp/borrower/loan/${loanId}/milestone`);
};

export const otpBorrowerLogout = async () => {
    sessionStorage.removeItem("borrowerToken");
  sessionStorage.removeItem("borrowerUser");
  return apipostOtp("otp/borrower/logout", {});
};
